import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import './ECup.component.scss';
import { create } from '../../services/e-cup.service';
import eCupHeroImg from '../../assets/images/ecup-hero.jpeg';
import Regexp from '../../constants/regexp';


function ECup() {

    /** component will-mount */
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const eCupFormDefaultValues = {
        participantName: '',// Full Name
        email: '',// Email
        phone: '',// Telephone Number
        dateOfBirth: '',// DOB
        gamerTag: '',// Gamertag (PlayStation Only)     (PlayStation Only)
        dietaryRequirements: '',// Dietary Requirements      optional
        accessRequirements: ''// Access Requirements     optional
    };
    const [isRequestAlive, setIsRequestAlive] = useState(false);
    const [eCupFormSubmitted, setECupFormSubmitted] = useState(null);
    const { register, handleSubmit, formState: { errors, isDirty, isValid }, getValues, reset } = useForm({
        mode: 'all',
        defaultValues: eCupFormDefaultValues
    });

    const onSubmit = (data, e) => {
        e.preventDefault();
        try {
            if (!isValid || !isDirty || isRequestAlive) {
                return;
            } else {
                setIsRequestAlive(true);
                create(data).then((res) => {
                    setIsRequestAlive(false);
                    const response = res.data;
                    if (response.code === 'CREATED') {
                        reset(eCupFormDefaultValues);
                        setECupFormSubmitted(setTimeout(() => {
                            setECupFormSubmitted(null);
                        }, 8000));
                    }
                }).catch(err => {
                    setIsRequestAlive(false);
                    console.log('Error while creating music studio enquiry', err?.response?.data);
                });
            }
        } catch (error) {
            setIsRequestAlive(false);
            console.log(`Error while register user`, error);
        }
    }




    return (
        <div className="e-cup-wrapper">
            <div className='hero-section'>
                {/* <img src={eCupHeroImg} className='hero-img' alt='' /> */}
                {/* <picture>
                    {/ * small size * /}
                    <source media='(max-width: 768px)' srcSet={eCupHeroImg} />
                    {/ * large size * /}
                    <source media='(min-width: 769px)' srcSet={eCupHeroImg} />
                    {/ * set default size * /}
                    <img srcSet={eCupHeroImg} className='hero-img' draggable="false" alt="E-Cup here" />
                </picture> */}
                <img srcSet={eCupHeroImg} className='hero-img' draggable="false" alt="E-Cup here" />
            </div>

            <div className='e-cup-spacing'>
                <div className='e-cup-desc'>
                    <p className='description-text'>
                        Introducing the #Merky FC eCup. A community focused tournament, designed to find the next best gamer. 
                        <br /> 
                        <b>Saturday 28th June</b>, adidas #Merky FC and EA SPORTS FC welcome football fans everywhere to show up at their best, and win the coveted title of champion, of the #Merky FC eCup. 
                        <br /><br /> 128 players will take to the controllers and play in a traditional 1v1 kick-off fixture, with their team of choice in EA SPORTS FC 25 in a full tournament bracket, that see one winner take home a grand prize courtesy of adidas and EA SPORTS FC. 
                        <br /><br />You must be 16+ to participate.

                    </p>
                </div>

                <form className='music-studio-form-wrap' onSubmit={handleSubmit((data, e) => onSubmit(data, e))} autoComplete="off">
                    <div>
                        <div className='music-studio-form-item'>
                            <input className='music-studio-form-item-input' type='text' name='participantName' placeholder='Full Name'
                                {...register('participantName', { required: 'First Name is required.' })} />
                        </div>
                        {(errors?.participantName) && (<h4 className='music-studio-form-item-err-msg'>
                            {errors.participantName.message}
                        </h4>)}
                    </div>

                    <div>
                        <div className='music-studio-form-item'>
                            <input className='music-studio-form-item-input' type='text' name='phone' placeholder='Telephone Number'
                                {...register('phone', {
                                    required: 'Telephone number is required.',
                                    pattern: {
                                        value: Regexp._MOBILE_NUMBER,
                                        message: 'Please enter valid telephone number.'
                                    }
                                })} />
                        </div>
                        {(errors.phone) && (<h4 className='music-studio-form-item-err-msg'>
                            {errors.phone.message}
                        </h4>)}
                    </div>

                    <div>
                        <div className='music-studio-form-item'>
                            <input className='music-studio-form-item-input' type='text' name='email' placeholder='email'
                                {...register('email', {
                                    required: 'Email is required.',
                                    pattern: {
                                        value: Regexp._EMAIL,
                                        message: 'Please enter valid e-mail address.'
                                    },
                                    validate: (value) => (value?.length > 254 ? 'An email address must not exceed 254 characters.' : null)
                                })} />
                        </div>
                        {(errors.email) && (<h4 className='music-studio-form-item-err-msg'>
                            {errors.email.message}
                        </h4>)}
                    </div>

                    <div>
                        <div className='music-studio-form-item dob-wrap'>
                            <input className={'music-studio-form-item-input date-time-icon' + (getValues('dateOfBirth') ? '' : ' date-time')} type='date' name='dateOfBirth'
                                {...register('dateOfBirth', {
                                    required: 'Date is required.',
                                    validate: (value) => {
                                        const inputDate = new Date(value);
                                        return (!isNaN(inputDate) && inputDate instanceof Date) ? true : 'Please enter a valid date of birth.';
                                    }
                                })} />
                            <label htmlFor='dateOfBirth' className='date-of-birth-label'>Date of Birth</label>
                        </div>
                        {(errors.dateOfBirth) && (<h4 className='music-studio-form-item-err-msg'>
                            {errors.dateOfBirth.message}
                        </h4>)}
                    </div>

                    <div>
                        <div className='music-studio-form-item'>
                            <input className='music-studio-form-item-input' type='text' name='gamerTag' placeholder='Gamertag (PlayStation Only)'
                                {...register('gamerTag', {
                                    validate: (value) => {
                                        if (!value?.trim()) {
                                            return 'Gamer Tag is required.';
                                        }
                                        return true;
                                    }
                                })} />
                        </div>
                        {(errors.gamerTag) && (<h4 className='music-studio-form-item-err-msg'>
                            {errors.gamerTag.message}
                        </h4>)}
                    </div>

                    <div>
                        <div className='music-studio-form-item multiline'>
                            <textarea className='music-studio-form-item-input' name='dietaryRequirements' placeholder='Dietary Requirements (optional)'
                                {...register('dietaryRequirements')}></textarea>
                        </div>
                    </div>

                    <div>
                        <div className='music-studio-form-item multiline'>
                            <textarea className='music-studio-form-item-input' name='accessRequirements' placeholder='Access Requirements (optional)'
                                {...register('accessRequirements')}></textarea>
                        </div>
                    </div>


                    <div className='music-studio-form-action-wrapper'>
                        <button className='music-studio-form-action-btn' type='submit' disabled={isRequestAlive}>
                            {isRequestAlive ? 'Submitting...' : 'Submit'}
                        </button>
                    </div>
                </form>
            </div>

            {eCupFormSubmitted && (
                <div className='e-cup-form-submitted-wrapper'>
                    <div className='e-cup-form-submitted' onClick={() => setECupFormSubmitted(null)}>
                        <h4 className='e-cup-form-submitted-text'>
                            Thank you, we have received your request.
                        </h4>
                        <button className='e-cup-form-submitted-close-btn' onClick={() => setECupFormSubmitted(null)}>Ok</button>

                        <div className='e-cup-form-submitted-close-icon' onClick={() => setECupFormSubmitted(null)}>
                            <svg viewBox="0 0 32 32" fill="none">
                                <path d="M32 4.03186L27.9681 0L16.0116 11.9566L4.03186 0L0 4.03186L11.9566 16.0116L0 27.9681L4.03186 32L16.0116 20.0434L27.9681 32L32 27.9681L20.0434 16.0116L32 4.03186Z" fill="#1E1E1E" />
                            </svg>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ECup;